"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnauthenticatedUserService = void 0;
const service_1 = require("@phishtool/service");
const contact_request_1 = require("~server/controllers/service/users/contact-request");
const contact_sales_team_1 = require("~server/controllers/service/users/contact-sales-team");
const _middleware_1 = require("~middleware");
const service_schemas_1 = require("@phishtool/service-schemas");
class UnauthenticatedUserService extends service_1.Service {
    constructor() {
        super(...arguments);
        this.useSendContactRequest = this.addSingletonNonResourceMutation({
            controller: contact_request_1.loggedOutContactRequestHandler,
            schema: service_schemas_1.LoggedOutContactRequestDataSchema,
            middleware: [_middleware_1.recaptchaMiddleware, _middleware_1.rateLimitMiddleware],
            routeId: 'contact-request',
        });
        this.useContactSalesTeam = this.addSingletonNonResourceMutation({
            controller: contact_sales_team_1.unauthenticatedContactSalesTeamRequestHandler,
            schema: service_schemas_1.UnauthenticatedContactSalesTeamRequestDataSchema,
            middleware: [_middleware_1.recaptchaMiddleware, _middleware_1.rateLimitMiddleware],
            routeId: 'contact-sales-team',
        });
    }
}
exports.UnauthenticatedUserService = UnauthenticatedUserService;
